var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:grid md:grid-cols-3 lg:grid-cols-5 xl:flex xl:items-center"},_vm._l((_vm.trophies),function(trophy){return _c('Card',{key:trophy.id,attrs:{"trophy":trophy}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }